import s from './state'
import * as a from './actions'
import * as m from './mutations'
import * as g from './getters'

export const state = s
export const actions = { ...a }
export const mutations = { ...m }
export const getters = { ...g }
